import { Action } from 'redux';
import { NlpSetting } from '../../ts/models/IDataSourceInfo';
import { UpdateNlpSetting } from './AppActionTypes';

export interface UpdateNlpSettingAction extends Action {
  nlpSetting: NlpSetting;
  feedbackToCurator: boolean;
}

export const updateNlpSetting = (nlpSetting: NlpSetting, feedbackToCurator: boolean): UpdateNlpSettingAction => ({
  type: UpdateNlpSetting,
  nlpSetting,
  feedbackToCurator,
});
